import { combineReducers } from 'redux';
import CreateEventReducer from './admin/create-event';
import PasscodeListReducer from './admin/passcode-lists';
import EventsReducer from './admin/events';
import RegistrationQuestionsReducer from './admin/registration-questions';
import PageReducer from './admin/page';
import AuthReducer from './authentication';
import RegisteredUsersReducer from './admin/people';
import QuizzesReducer from './admin/quizzes';
import SurveysReducer from './admin/surveys';
import ContentReducer from './admin/content-reducer';
import SpeakersReducer from './admin/speakers';
import PasscodeListMembersReducer from './admin/passcode-list-members';
import ProductsReducer from './admin/products';
import SponsorsReducer from './admin/sponsors';
import DocumentsReducer from './admin/documents';
import MessagesReducer from './messages/messages';
import CreateSessionReducer from './admin/create-event/sessions';
import ChannelAdminReducer from './admin/bl-admin';
import EventPanelReducer, { initialEventPanelState } from './admin/event-panel';
import LiveEventReducer from './event/event-reducer';
import AssistantReducer from './admin/assistant';
import VideosReducer from './admin/videos';
import IntegrationsReducer from './admin/integrations';
import AnalyticsReducer from './admin/analytics';
import ModeratorReducer from './moderator/moderator';
import ChatReducer from './event/chat-reducer';
import QuestionsReducer from './event/questions-reducer';
import PaidListMemberReducer from './admin/paid-list-members';
import { SIGN_OUT } from '../actions/authentication';
import { Action } from '../../types/actions';
import { removeStorageItem } from '../../utils/local-storage';

const appReducers = combineReducers({
	CreateEventReducer,
	EventsReducer,
	PasscodeListReducer,
	RegistrationQuestionsReducer,
	PageReducer,
	AuthReducer,
	RegisteredUsersReducer,
	QuizzesReducer,
	SurveysReducer,
	ContentReducer,
	SpeakersReducer,
	PasscodeListMembersReducer,
	ProductsReducer,
	SponsorsReducer,
	DocumentsReducer,
	CreateSessionReducer,
	ChannelAdminReducer,
	MessagesReducer,
	EventPanelReducer,
	LiveEventReducer,
	AssistantReducer,
	VideosReducer,
	IntegrationsReducer,
	AnalyticsReducer,
	ModeratorReducer,
	ChatReducer,
	QuestionsReducer,
	PaidListMemberReducer
});

export type RootState = ReturnType<typeof appReducers>;

// I cannot figure out what type state should be,
// setting it to EventsState makes createStore inside of './store/main.ts' throw an error,
// so I'm disabling it:
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const rootReducer = (state: any, action: Action): RootState => {
	// on signout, clear event panel reducer so it renders appropriately when logging back in
	if (action.type === SIGN_OUT) {
		removeStorageItem('activityTime');
		const updatedState = {
			...state,
			EventPanelReducer: { ...initialEventPanelState },
		};
		return appReducers(updatedState, action);
	}
	return appReducers(state, action);
};

export default rootReducer;
